import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatDate',
    standalone: true
})
export class FormatDatePipe implements PipeTransform {

  transform(value: string): string | null {
    if (!value) return null;
    
    const dateParts = value.split('-');
    if (dateParts.length !== 3) return null;

    const year = parseInt(dateParts[0], 10);
    const month = parseInt(dateParts[1], 10) - 1; // Mês começa do zero
    const day = parseInt(dateParts[2], 10);

    const date = new Date(Date.UTC(year, month, day));
    if (isNaN(date.getTime())) return null;

    const formattedDay = ('0' + date.getUTCDate()).slice(-2);
    const formattedMonth = ('0' + (date.getUTCMonth() + 1)).slice(-2);
    const formattedYear = date.getUTCFullYear();

    return `${formattedDay}/${formattedMonth}/${formattedYear}`;
  }
}